import { useMemo } from 'react';
export const useModifiers = ({ preventAutoPositioning }) => {
    const modifiers = useMemo(() => {
        if (preventAutoPositioning)
            return [
                {
                    name: 'flip',
                    options: {
                        fallbackPlacements: [],
                    },
                },
                {
                    name: 'preventOverflow',
                    options: {
                        enabled: false,
                    },
                },
                {
                    name: 'computeStyles',
                    options: {
                        gpuAcceleration: false,
                    },
                },
            ];
        return [];
    }, [preventAutoPositioning]);
    return modifiers;
};
